import { observer } from "mobx-react-lite";
import { Button } from "../../../Button";
import React from "react";

type IErrorActionsProps = {
  hasCamera: boolean;
  onRetryUpload: () => void;
  onRetryCamera: () => void;
  source: "camera" | "file" | undefined;
  translation: {
    retakePic: string;
    reUpload: string;
    takePic: string;
    upload: string;
  };
};

export const ErrorActions: React.FC<IErrorActionsProps> = observer((props) => {
  const {
    hasCamera,
    onRetryCamera,
    onRetryUpload,
    source,
    translation,
  } = props;

  return (
    <>
      {hasCamera && (
        <Button id="retry-picture-btn" onClick={onRetryCamera}>
          {source === "camera" ? translation.retakePic : translation.takePic}
        </Button>
      )}
      <Button outline id="retry-upload-picture-btn" onClick={onRetryUpload}>
        {source === "file" ? translation.reUpload : translation.upload}
      </Button>
    </>
  );
});
